import React, { useCallback } from 'react';
import { StyleSheet, View } from 'react-native';
import { useAppSelector } from 'store/hooks';
import { Button, Spacer } from 'design-system';
import Text from 'design-system/Text';
import ProgressCard from 'features/invest/components/InvestOnboardingFunnel/ProgressCard';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { showUnavailableOnWeb } from 'utils/webGate';
const SetupAutosaveProgressCard = () => {
    const navigation = useMainStackNavigation();
    const hasFundedPot = useAppSelector((state) => state.pots.hasFundedPot);
    const hasCreatedPot = useAppSelector((state) => state.pots.hasCreatedPot);
    const hasInitiatedDepositToPot = useAppSelector((state) => state.pots.hasInitiatedDepositToPot);
    const hasFunded = hasFundedPot || hasInitiatedDepositToPot;
    const isActiveStep = !!(!!hasCreatedPot && !!hasFunded);
    const handleCreatePot = useCallback(() => {
        if (showUnavailableOnWeb('emma://auto-save', 'Set up Autosave')) {
            return;
        }
        navigation.navigateDeprecated('AutosaveIntro');
    }, []);
    return (<ProgressCard lightBg completed={false} timeInfo="< 1 minute" isActiveStep={isActiveStep} title="Autosave" lastItem>
      <Text TextThin-14 Secondary>
        Start saving without thinking with Emma’s automation
      </Text>
      {!!isActiveStep && (<>
          <Spacer h={12}/>
          <View style={styles.row}>
            <Button brandLight hug extra square title="Setup autosave" onPress={handleCreatePot}/>
          </View>
        </>)}
    </ProgressCard>);
};
const styles = StyleSheet.create({
    row: {
        flexDirection: 'row',
    },
});
export default SetupAutosaveProgressCard;
